import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Box,
  // Button,
  Card,
  CardContent,
  FormControl,
  // TextField,
  // InputAdornment,
  InputLabel,
  MenuItem,
  // SvgIcon,
  Select,
  makeStyles
} from '@material-ui/core';
// import { Search as SearchIcon } from 'react-feather';

const useStyles = makeStyles((theme) => ({
  root: {},
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

const Toolbar = ({
  className,
  role,
  roleList,
  handleRoleChange,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <div
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Box mt={3}>
        <Card>
          <CardContent>
            <Box maxWidth={500}>
              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="role-select">Role</InputLabel>
                <Select
                  id="role-select"
                  value={role}
                  onChange={handleRoleChange}
                  // input={<BootstrapInput />}
                >
                  {roleList.map((v) => (
                    <MenuItem value={v.id} key={v.id}>
                      {v.role_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </div>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string,
  role: PropTypes.number,
  roleList: PropTypes.array,
  handleRoleChange: PropTypes.func,
};

export default Toolbar;
